import styled from "styled-components";

export const ExplanationParagraph = styled.p`
	margin: 1em 0 0 0;
	&:last-of-type {
		margin-bottom: 1.5em;
	}
`;
